import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.typebtn !== 'text'&&_ctx.typebtn !== 'danger')
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          onClick: _ctx.openModal,
          type: _ctx.typebtn
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btnName), 1)
          ]),
          _: 1
        }, 8, ["onClick", "type"]))
      : _createCommentVNode("", true),
    (_ctx.typebtn == 'danger')
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          onClick: _ctx.openModal,
          danger: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btnName), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.typebtn == 'text')
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          href: "javascript:void(0);",
          type: "link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
          class: "theme-color",
          style: _normalizeStyle(_ctx.btnName == '终止合同' ?{ color: '#2F7BFF'} : {color: '#ff4d4f'})
        }, _toDisplayString(_ctx.btnName), 5))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      centered: true,
      keyboard: false,
      "mask-closable": false,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: "终止合同",
      "ok-text": "确认",
      "cancel-text": "取消",
      onOk: _ctx.ok
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          model: _ctx.formModel,
          ref: "formRef",
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "终止合同原因分类",
              name: "reason"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "请选择",
                  "option-filter-prop": "title",
                  value: _ctx.formModel.reason,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.code,
                        value: item.code,
                        title: item.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "title"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "终止合同原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  placeholder: "请输入项目关闭原因",
                  value: _ctx.formModel.remark,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.remark) = $event)),
                  showCount: "",
                  rows: 4,
                  maxlength: 200
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}